export default {
  app: {
    place: {
      address: '地址',
      showOnExternalMaps: '在谷歌地图上显示',
    },
  },
};
